export default {
  placeholder: 'Vybrať štítok',
};
